module.exports = __webpack_public_path__ + "img/index-security-bottom4.8d29ab25.svg";